import { BaseFactory } from '../base.factory';
import { Company } from '../../../store/auth/types';

export class CompanyFactory extends BaseFactory {

    constructor() {
        super(true, true);
    }

    public getAll = async (companies: Array<string>) => {
        try {
            const result = await this.get(`/company/all?busCompany=${companies}`);
            return result;
        }
        catch (error) {
            throw error;
        }
    }
}
